module.exports = __webpack_public_path__ + "media/components/terrain-mapping/icons/Water Source-e0a6a193f2547af4ed06540d2f8a073d.png";